'use client'
import React, { useState } from 'react'
import VideoModal from '@/components/videoModel';
import Image from 'next/image';

import boysThumbnail from "@/assets/hostel/boys-hostel.webp";
import girlsThumbnail from "@/assets/hostel/girls-hostel.webp";

const HostelVideo = () => {
    const [modal, setModal] = useState({ open: false, url: "" });
    const hosteData = [
        { thumbImg: boysThumbnail, url: "https://www.youtube.com/embed/Eu4MyC-WfLo?si=5sNuJDjHwViidaSK", tilte: "Boys Hostel Tour" },
        { thumbImg: girlsThumbnail, url: "https://www.youtube.com/embed/aqW6fyQNNdQ?si=VuccXHFHjwC0zf90", tilte: "Girls Hostel Tour" },
    ]
    return (
        <div className='w-full'>
            <VideoModal
                open={modal.open}
                url={modal.url}
                onClose={() => setModal({ open: false, url: "" })}
            />
            <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-6">
                {hosteData.map((ele, index) => (
                    <div key={index} className="w-full">

                        <div className="relative overflow-hidden shadow-md">
                            <Image
                                src={ele.thumbImg}
                                alt="Hoste-Thumbnail"
                                className="w-full h-full object-cover"
                            />

                            <div className="absolute inset-0 bg-black/50 z-10"></div>

                            <div className="absolute inset-0 flex items-center justify-center z-20">
                                <button
                                    onClick={() =>
                                        setModal({
                                            open: true,
                                            url: ele.url,
                                        })
                                    }
                                    className="flex justify-center items-center cursor-pointer w-12 h-12 md:w-14 md:h-14 rounded-full
            bg-white text-[#081E2D] p-3 shadow-lg hover:scale-105 transition"
                                >
                                    <Image
                                        src="/play.svg"
                                        alt="Play"
                                        width={18}
                                        height={22}
                                        className="ml-1.5"
                                    />
                                </button>
                            </div>
                        </div>

                        <h2 className="my-3 md:my-8 text-xl md:text-2xl lg:text-3xl font-semibold text-center">
                            {ele.tilte}
                        </h2>

                    </div>
                ))}
            </div>

        </div>
    )
}

export default HostelVideo